/* eslint-disable no-script-url  */
/* eslint-disable no-new  */
import DOMPurify from 'dompurify'
import { EMBED_URL_STRATEGIES } from '@/utils/url.utils'
// Helper: checks if a string is a valid http/https URL
function isValidHttpUrl(str) {
  try {
    const url = new URL(str)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
}

// Helper: checks if an iframe string has a valid http/https src
function isValidIframe(str) {
  if (!str.toLowerCase().includes('<iframe')) return false
  const match = str.match(/src=["']([^"']+)["']/i)
  return match && isValidHttpUrl(match[1])
}

export const sanitizeEmbedSrc = (inputValue) => {
  // Empty string is considered valid
  if (inputValue === '') {
    return { isValid: true, sanitizedInputValue: '' }
  }

  // Null/undefined are invalid
  if (!inputValue) {
    return { isValid: false, sanitizedInputValue: '' }
  }

  // Block javascript: URLs
  if (inputValue.toLowerCase().includes('javascript:')) {
    return { isValid: false, sanitizedInputValue: '' }
  }

  // Sanitize, allowing iframes and common attributes
  const sanitizedValue = DOMPurify.sanitize(inputValue, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'width', 'height'],
    ALLOWED_URI_REGEXP: /^(?:(?:https?):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
  })

  // If sanitization results in empty string but input had content, it's invalid
  if (sanitizedValue === '' && inputValue.length > 0) {
    return { isValid: false, sanitizedInputValue: '' }
  }

  // Valid http/https URL
  if (isValidHttpUrl(inputValue)) {
    return { isValid: true, sanitizedInputValue: inputValue }
  }

  // Valid iframe embed code
  if (isValidIframe(sanitizedValue)) {
    return { isValid: true, sanitizedInputValue: sanitizedValue }
  }

  // Otherwise, invalid
  return { isValid: false, sanitizedInputValue: sanitizedValue }
}

export const getEmbeddableLink = (originalEmbedSrc) => {
  // Find the first matching strategy and apply it
  const matchingStrategy = Object.entries(EMBED_URL_STRATEGIES).find(([key]) => originalEmbedSrc.includes(key))

  return matchingStrategy
    ? matchingStrategy[1](originalEmbedSrc)
    : originalEmbedSrc
}
